import React, {useEffect, useState} from "react";
import RequestHelper from "src/Lib/Helper/RequestHelper";
import {toast} from "react-toastify";

const LanguageSelector = ({
    labelClass= "block font-14 text-gray-700 mb-1 mt-4",
    inputClass= "bg-light w-full font-14 p-2 rounded-xl border",
                              params,
                              setParams
                          }) => {
    const [languages, setLanguages] = useState([]);
    const [loader, setLoader] = useState([]);
    // Fetch languages and countries with states and cities on component mount
    useEffect(() => {
        const fetchData = async () => {
            setLoader(true);
            try {
                const languageRes = await RequestHelper.get("NPAN_METABRO_MNGR", "/dyna/Language", {});

                if (languageRes.success) {
                    setLanguages(languageRes.object);
                } else {
                    toast.error("Failed to fetch data for dropdowns.");
                }
            } catch (error) {
                toast.error("An error occurred while loading data.");
            }
            setLoader(false);
        };

        fetchData();
    }, []);

    const handleInputChange = (event) => {
        const {name, value} = event.target;

        if (name === "language") {
            const selectedLanguage = languages.find((language) => language._id === value);
            setParams({
                ...params,
                [name]: selectedLanguage?.slug || "",
                languageId: value,
            });
        } else {
            setParams({
                ...params,
                [name]: value,
            });
        }
    };

    return (
        <>
            <label className={labelClass}>Language:</label>
            <select
                name="language"
                value={params.languageId}
                onChange={handleInputChange}
                required
                className={inputClass}
            >
                <option value="">Select</option>
                {languages.map((language) => (
                    <option key={language._id} value={language._id}>
                        {language.name}
                    </option>
                ))}
            </select>
        </>
    );
};

export default LanguageSelector;
